









import displayStore from '@/store/modules/display/displayStore';
import { Component, Model, Vue, Watch } from 'vue-property-decorator';

const visibleChangedEvent = 'visible-changed';

@Component({})
export default class MobileMenu extends Vue {
  @Model(visibleChangedEvent)
  public isVisible!: boolean;

  public get isMobile(): boolean {
    return displayStore.getters.isMobile();
  }

  @Watch('isVisible')
  @Watch('isMobile')
  private async onVisibleChanged(): Promise<void> {
    if (this.isVisible && this.isMobile) {
      await displayStore.dispatch.registerOverlayMenu(() => {
        this.$emit(visibleChangedEvent, false);
      });

      // Prevent scrolling but remember the current scroll position
      document.body.style.top = `-${window.scrollY}px`;
      document.body.style.position = 'fixed';
    } else {
      if (this.isVisible) {
        await displayStore.dispatch.closeOverlayMenu();
      }
      await displayStore.dispatch.unregisterOverlayMenu();

      // Enable scrolling again and scroll to the position before the overlay was opened
      const scrollY = document.body.style.top;
      document.body.style.position = '';
      document.body.style.top = '';
      window.scrollTo(0, parseInt(scrollY || '0') * -1);
    }
  }
}
